<template>
  <EditForm :question="question"/>
</template>

<script>
import EditForm from '@/pages/admin/questions/practice/EditForm'
import PracticeQuestionService from '@/services/PracticeQuestionService'

export default {
  components: {EditForm},
  data: () => ({
    question: PracticeQuestionService.getDefaultItem()
  })
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/admin/questions/practice/Add.vue